import { useContext } from '@wordpress/element';
import { ToggleSidebarContext } from '../../App.jsx';
import { totalItemsInCart } from './util';
import { useCartData } from '../../hooks/dutchie-queries.js';
import { RetailerIdContext } from '../../App.jsx';
import CartIcon from '../Icons/CartIcon.jsx';

const CartSidebarIcon = ({ fixedCart }) => {
    const { setSidebarToggle } = useContext(ToggleSidebarContext);
    const retailerId = useContext(RetailerIdContext);
    const { data: cartData, isFetched: isFetchedCartData } = useCartData(retailerId);

    return (
        <button
            className={fixedCart ? 'headless-cart-icon-fixed' : 'headless-cart-icon'}
            onClick={() => setSidebarToggle(true)}
            aria-label='Add to Cart'
            role='link'
            tabIndex='0'
        >
            <span aria-hidden='true'>
                <CartIcon />
            </span>
            {isFetchedCartData && totalItemsInCart(cartData) > 0 ? (
                <div className='headless-cart-icon-qty' aria-hidden='true'>
                    {totalItemsInCart(cartData)}
                </div>
            ) : null}
        </button>
    );
};

export default CartSidebarIcon;
